import { configureStore } from "@reduxjs/toolkit";
import { sentryReduxEnhancer } from "@helpers/logException";
import { persistStore } from "redux-persist";
import rootReducer from "./rootReducer";

export const store = configureStore({
  reducer: rootReducer,
  enhancers: [sentryReduxEnhancer],
});

export const persistor = persistStore(store);

export default store;
